import { Box, FormControlLabel, Stack, TextField, Button, Tooltip, Typography, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, Switch, IconButton, Autocomplete, RadioGroup, Radio, Dialog } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import { CommonDeleteButton, CommonEditButton } from '../../../Components/Common Components/CommonComponents'
import CommonValidation from '../../../Components/CommonFunctions/CommonValidation'
import { ImagePaths } from '../../../Utility/ImagePaths'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import { useHistory, useLocation } from 'react-router-dom'
import Loader from '../../../Components/Loader';
import { CurrencySymbol } from '../../../Utility/Constants'
import { AmountFormat, ContentInTooltip } from '../../../Components/CommonFunctions/CommonFunctions'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { localGetItem } from '../../../Utility/Services/CacheProviderService'

const assStates = {
    assPackCode: '',
    assPackName: '',
    finalAmt: '',
}
const list = ['Consumable', 'Non Consumable']

const applied_for = [
    { label: 'OP', value: 'OP' },
    { label: 'IP', value: 'IP' },
    { label: 'Both OP and IP', value: 'IP_OP' },
]
export default function AssortedPackageAdd() {
    const history = useHistory();
    const location = useLocation();
    const [assData, setassData] = useState(assStates);
    const [headText, setheadText] = useState('');
    const [headTbl, setheadTbl] = useState([]);
    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    })
    const [Index, setIndex] = useState(null);
    const [serviceType, setserviceType] = useState(null);
    const [serviceName, setserviceName] = useState(null);
    const [serviceQty, setserviceQty] = useState('');
    const [serAmt, setserAmt] = useState('');
    const [editHead, seteditHead] = useState('');
    const [isDrug, setisDrug] = useState(false);
    const [selPack, setselPack] = useState(null);
    const [IPPackage, setIPPackage] = useState([]);
    const [DrugPackage, setDrugPackage] = useState([]);
    const [serTypeData, setserTypeData] = useState([]);
    const [serNameData, setserNameData] = useState([]);
    const [MediserNameData, setMediserNameData] = useState([]);
    const [EditID, setEditID] = useState(null);
    const [EditListID, setEditListID] = useState(null);
    const [deletedIDs, setdeletedIDs] = useState([]);
    const [headIDs, setheadIDs] = useState([]);
    const [isloader, setisloader] = useState(false);
    const [serData, setserData] = useState([]);
    const [isDrugEdit, setIsDrugEdit] = useState(false)
    const [states, setStates] = useState({
        selectedRadio: 'Assorted Package Name',
        selectedTypeRadio: 'Service'
    })
    const [serviceInputValue, setServiceInputValue] = useState('')
    const [searchDrug, setSearchDrug] = useState('')
    const [appliedFor, setAppliedFor] = useState(null)
    let userLogin = JSON.parse(localGetItem('loggedInUserInfo'))
    const [loginInfo, setLoginInfo] = useState(userLogin)
    const [selPharmacy, setSelPharmacy] = useState(null)
    const [drugData, setDrugData] = useState([])
    const [maxQty, setMaxQty] = useState(0)
    const [editData, setEditData] = useState({
        assHeadEdit: false,
        hasServiceData: false
    })
    const [drugAmt, setDrugAmt] = useState(0)
    const [fromUpdate, setFromUpdate] = useState(false)
    const [openAlertPopup, setOpenAlertPopup] = useState(false)
    const [radioType, setRadioType] = useState('')
    const [pharmacyList, setPharmacyList] = useState([])

    useEffect(() => {
        // getIPackageService()
        getDrugPackageService()
        // getServiceType()
        getDrugDetails()
        getlocationlist()
    }, [])

    useEffect(() => {
        // if (isDrug && serviceType) {
        // getDrugDetails()
        // }
        if (location.states) {
            let data = location.states.line_items
            setheadTbl(data)
            setEditListID(location.states.id)
            setassData({ assPackCode: location.states.pack_code, assPackName: location.states.pack_name, finalAmt: location.states.pack_amount, })
            setAppliedFor(location.states.module_type)
            setStates((prev) => ({ ...prev, selectedRadio: location?.states?.billing_display }))
            let hasData = data?.length ? true : false
            setFromUpdate(hasData)
        }
    }, [])

    useEffect(() => {
        if (headTbl && headTbl.length > 0) {
            setheadTbl((currentHeadTbl) => {
                let hasChanges = false;

                const updatedHeadTbl = currentHeadTbl.map((item) => {
                    const total_amount = item?.service_data?.length > 0
                        ? item.service_data.reduce((sum, ser) => +(sum + +(ser.amount || 0)).toFixed(2), 0)
                        : 0;
                    if (item.total_amount !== total_amount) {
                        hasChanges = true;
                        return {
                            ...item,
                            total_amount,
                        };
                    }
                    return item;
                });
                return hasChanges ? updatedHeadTbl : currentHeadTbl;
            });
        }
    }, [headTbl]);


    useEffect(() => {
        if (headTbl && headTbl.length > 0) {
            const headTotalAmt = headTbl.reduce(
                (sum, head) => sum + parseFloat(head.total_amount || 0),
                0
            );
            setassData(prev => ({ ...prev, finalAmt: +headTotalAmt.toFixed(2) }));

            let hasData = headTbl?.some(assHead => assHead?.service_data?.length > 0)
            setEditData((prev) => ({ ...prev, hasServiceData: hasData }))
        }
    }, [headTbl]);

    useEffect(() => {
        if (serviceInputValue) {
            const handler = setTimeout(() => {
                if (serviceInputValue.trim() !== '') {
                    getServiceListData(serviceInputValue)
                }
            }, 300);

            return () => clearTimeout(handler);
        }
        if (searchDrug) {
            const handler = setTimeout(() => {
                if (searchDrug.trim() !== '') {
                    searchPharamcyDrugData(searchDrug)
                }
            }, 300);

            return () => clearTimeout(handler);
        }
    }, [serviceInputValue, searchDrug]);

    const getDrugDetails = () => {
        try {
            RestAPIService.getAll(Serviceurls.ASS_GET_DRUG_MASTER)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const filData = response.data.data
                        setMediserNameData(filData || [])
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }
    const getlocationlist = () => {
        try {
            RestAPIService.getAll(Serviceurls.SUBLOC_FROM_LOCATION_GET)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const locationData = response.data.data
                        setPharmacyList(locationData || [])
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }
    const getIPackageService = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.FO_CONFIG_IPSRCPACKAGE)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setisloader(false)
                        setIPPackage(response?.data?.data || [])
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const getDrugPackageService = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.ASS_GET_DRUG_PACKAGE)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setisloader(false)
                        setDrugPackage(response?.data?.data || [])
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }
    const getServiceType = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.IP_NEW_SERVICE_CONFIGURATION)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setisloader(false)
                        setserTypeData(response?.data?.data || [])
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const getServiceListData = (searchKey) => {
        try {
            let module = appliedFor?.value || appliedFor
            RestAPIService.getAll(Serviceurls.CONFIGURATION_SERVICE_SEARCH + `?search_key=${searchKey}&module_type=${module}&all_doctor=${false}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setserTypeData(response?.data?.data)
                    }
                }).catch(e => {
                    if (e?.response?.data?.message) {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const searchPharamcyDrugData = (searchDrug) => {
        try {
            RestAPIService.getAll(Serviceurls.PHARMA_BILLING_BRAND_SEARCH + `?pharmacy_id=${selPharmacy?.pharmacy_id || selPharmacy?.sub_pharmacy_id}&search=${searchDrug}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setDrugData(response?.data?.data)
                    }
                }).catch(e => {
                    if (e?.response?.data?.message) {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const errorMessage = (message) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: message,
            transmit: false,
            saveLoad: false
        })
    }

    const successMessage = (message) => {
        setMessage({
            ...message,
            successMsg: true,
            successMsgText: message,
        })
    }

    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }


    const textBox = (label, name, val, width, disable = false) => {
        return (
            <TextField
                size='small'
                name={name}
                value={val}
                disabled={name === 'finalAmt' || disable}
                id="drug-master"
                sx={{ width: width, marginRight: '1vw' }}
                label={label}
                onChange={(e) => { onChangeHandler(e, name) }}
                variant="outlined"
            />
        )
    }

    const onChangeHandler = (e, name) => {
        let value = e.target.value
        let numval = CommonValidation.NumberWithDot(value);
        switch (name) {
            case 'assPackCode':
                let valid = CommonValidation.ALPHA_NUMARIC(value)
                if (value === "" || valid && value.length <= 20) {
                    setassData({ ...assData, [name]: value })
                }
                break
            case 'assPackName':
                if (value === "" || value.length <= 100) {
                    setassData({ ...assData, [name]: value })
                }
                break
            case 'serviceQty':
                let validnum = CommonValidation.numberOnly(value)
                if (value === "" || validnum && value.length <= 5) {
                    setserviceQty(value)
                    if (drugAmt) setserAmt(value * drugAmt)
                }
                break
            case 'serAmt':
                if (value === '' || numval && value.length <= 10) {
                    setserAmt(value)
                }
                break
            default:
                if (value === '' || numval && value.length <= 10) {
                    setassData({ ...assData, [name]: value })
                }
                break
        }
    }

    const checkAssortedHeadValid = () => {
        try {
            let message = null
            if (!headText) {
                message = 'Please Enter the Assorted Service Head'
            } else if (headTbl?.length > 0) {
                headTbl?.forEach((element, ind) => {
                    if (ind !== Index) {
                        if (CommonValidation.removeSpace(element?.service_head) === CommonValidation.removeSpace(headText)) {
                            message = 'Assorted Service Head already exists'
                        }
                    }
                })
            }
            return message;
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const onAddService = () => {
        let checkValid = checkAssortedHeadValid()
        if (checkValid !== null) {
            errorMessage(checkValid);
        } else {
            let data = {
                "service_head": headText,
                "service_data": serData.length > 0 ? serData : [],
                "index_no": Index + 1
            };

            if (Index !== undefined && Index !== null) {
                const editPackList = headTbl.map((item, i) =>
                    i === +Index ? { ...item, ...data } : item
                );
                setheadTbl(editPackList);
            } else {
                setheadTbl(prevHeadTbl => [...prevHeadTbl, data]);
            }

            setheadText('');
            setIndex(null);
            seteditHead('');
            setserData([])
            setEditData((prev) => ({ ...prev, assHeadEdit: false }))
        }
    };
    const Servicetbl = () => {
        return (
            <Box sx={{ width: '40vw', height: '60vh' }}>
                <TableContainer component={Paper} sx={{ height: '60vh' }}>
                    <Table size='small' sx={{ width: '40vw', }} aria-label="simple table">
                        <TableHead sx={{ backgroundColor: '#FAF9F9' }}>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold', width: '25vw' }}>Assorted Service Head</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', width: '10vw' }}>Total Amount</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', width: '5vw' }}>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell sx={{ width: '25vw' }}>
                                    <TextField
                                        size='small'
                                        value={headText}
                                        id="ass-service"
                                        sx={{ width: '16vw' }}
                                        placeholder='Service Head'
                                        onChange={(e) => {
                                            if (e.target.value === '' || e.target.value.length <= 100) {
                                                setheadText(e.target.value)
                                            }
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' && (e.target.value === '' || e.target.value.length <= 100)) {
                                                setheadText(e.target.value)
                                                onAddService()
                                            }
                                        }}
                                        variant="standard"
                                    />
                                </TableCell>
                                <TableCell sx={{ width: '10vw' }}>{'-'}</TableCell>
                                <TableCell sx={{ width: '5vw' }}>
                                    <Tooltip placement='top' title={'Add'}>
                                        <IconButton size='small' onClick={() => { onAddService() }}>
                                            <img component={'img'} src={ImagePaths.AddUserButton.default} alt='plus' style={{ width: '1.2vw', height: '1.2vw' }} />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                            {headTbl.length > 0 ? headTbl.map((item, i) => (
                                <TableRow sx={{ bgcolor: (editHead === item.service_head) ? '#d9d9d9' : 'white', cursor: 'pointer' }}>
                                    <TableCell sx={{ width: '25vw' }}>
                                        {item.service_head.length > 50 ?
                                            <Tooltip title={item.service_head} placement='top'><Typography fontSize={'1vw'}>{item.service_head.slice(0, 50) + '...'}</Typography></Tooltip> :
                                            <Typography fontSize={'1vw'}>{item.service_head}</Typography>}
                                    </TableCell>
                                    <TableCell sx={{ width: '10vw' }}>{AmountFormat(item.total_amount || 0)?.replace(`${CurrencySymbol}`, "")}</TableCell>
                                    <TableCell sx={{ width: '5vw' }}>
                                        <Stack direction="row" alignItems="center" spacing={4}>
                                            <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
                                                <CommonEditButton size="1.5vw" disable={editData?.assHeadEdit} onClick={() => { setIndex(i); setheadText(item.service_head); setserData(item.service_data); setEditData((prev) => ({ ...prev, assHeadEdit: true })) }} />
                                                <CommonDeleteButton size="1.5vw" disable={editData?.assHeadEdit} onClick={() => {
                                                    let updatedTbl = [...headTbl];
                                                    const removedService = updatedTbl[i];
                                                    if (removedService?.head_id) {
                                                        setheadIDs((prev) => [...prev, removedService.head_id]);
                                                    }
                                                    updatedTbl.splice(i, 1);
                                                    setheadTbl(updatedTbl);
                                                }} />
                                                <IconButton sx={{ height: '1.5dvw', width: '1.5dvw' }}
                                                    onClick={() => {
                                                        let pharma = item?.pharmacy_id || item?.sub_location_id ? pharmacyList?.find((ph) => (item?.pharmacy_id && ph?.pharmacy_id === item?.pharmacy_id) || (item?.sub_location_id && ph?.id === item?.sub_location_id)) : undefined;
                                                        seteditHead(item.service_head);
                                                        setselPack(null);
                                                        setserviceType(null);
                                                        setserviceName(null);
                                                        setserviceQty('');
                                                        setserAmt('');
                                                        setEditID(null);
                                                        setisDrug(false);
                                                        setIsDrugEdit(false);
                                                        setSelPharmacy(pharma || loginInfo?.pharmacy_data[0])
                                                        setStates((prev) => ({ ...prev, selectedTypeRadio: item?.assorted_head_type ? item?.assorted_head_type : 'Service' }))
                                                    }}>
                                                    <Box component={'img'} src={ImagePaths.LabViewButton.default} height={'1.5dvw'} width={'1.5dvw'} />
                                                </IconButton>
                                            </Stack>
                                        </Stack>
                                    </TableCell>
                                </TableRow>
                            )) : (
                                <TableRow>
                                    <TableCell colSpan={3} align="center">{'No Records To Be Shown'}</TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        )
    }

    const autoFeild = (label, name, val, list, width, dis, type) => {
        return (
            <Box>
                {name === 'serviceHead' || name === 'drugName' ?
                    (states.selectedTypeRadio !== 'Service' ?
                        <Autocomplete
                            size={'small'}
                            options={list}
                            disabled={dis || EditID}
                            name={name}
                            value={val}
                            getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.drug_name}
                            sx={{ width: width, marginRight: '1vw' }}
                            onChange={(event, newValue) => { onChangeAuto(event, newValue, name) }}
                            onInputChange={(e, newValue) => {
                                if (type === 'inhouse') {
                                    if (selPharmacy === null) {
                                        errorMessage('Select Pharmacy')
                                    } else {
                                        setSearchDrug(newValue)
                                    }
                                }
                            }}
                            renderInput={(params) => <TextField {...params} placeholder={label} variant='standard' />}
                        /> : <Autocomplete
                            size={'small'}
                            options={list}
                            disabled={dis || EditID}
                            name={name}
                            getOptionLabel={(option) => typeof (option) === 'string' ? option : `${option?.service_head_name || option?.service_head} ${option?.service_head_code ? `(${option?.service_head_code})` : ''} - ${option?.service_name} ${option?.service_code ? `(${option?.service_code})` : ''}`}
                            value={val}
                            sx={{ width: width, marginRight: '1vw' }}
                            onChange={(event, newValue) => { onChangeAuto(event, newValue, name) }}
                            onInputChange={(e, value) => {
                                if (value) {
                                    if (appliedFor === null) {
                                        errorMessage('Select applied for to search')
                                    } else {
                                        setServiceInputValue(value)
                                    }
                                }
                            }}
                            renderInput={(params) => <TextField {...params} placeholder={label} variant='standard' />}
                        />) :
                    <TextField
                        size='small'
                        disabled={dis}
                        name={name}
                        value={val}
                        id="drug-master"
                        sx={{ width: width, marginRight: '1vw' }}
                        placeholder={label}
                        onChange={(e) => { onChangeHandler(e, name) }}
                        variant="standard"
                    />}
            </Box>
        )
    }

    const onChangeAuto = (e, val, name) => {
        switch (name) {
            case 'serviceType':
                setserviceType(val);
                if (val?.data && Array.isArray(val.data)) {
                    setserNameData(val.data);
                }
                // if(isDrug){
                //     getDrugDetails()
                // }

                break;
            case 'serviceName':
                setserviceQty("1")
                setserviceName(val)
                setserAmt(val.amount ? val.amount : '')
                break;
            case 'serviceHead':
                setserviceName(val)
                setserviceType(val)
                setserviceQty('1')
                break;
            case 'drugName':
                if (states.selectedTypeRadio === 'Inhouse Drug') {
                    setserviceName(val)
                    setserviceType(val)
                    setserAmt(val?.mrp_per_quantity)
                    setserviceQty('1')
                    setMaxQty(val?.in_stock)
                    setDrugAmt(val?.amount)
                } else {
                    setserviceName(val)
                    setserviceType(val)
                    setserAmt(val?.amount)
                    setserviceQty('1')
                    setDrugAmt(val?.amount)
                }
                break;
            default:
                setserviceName(val);
                break;
        }
    };

    const onAddType = (e, val) => {
        setselPack(val)
    }
    const addServiceTbl = () => {
        // if (!isDrug) {
        //     setheadTbl((prev) => {
        //         return prev.map((item) => {
        //             if (item.service_head === editHead) {
        //                 const newServiceData = selPack?.service_data?.map((service, i) => ({
        //                     ...service,
        //                     quantity: service.quantity ? service.quantity : 1,
        //                     index_no: i + 1,
        //                     service_details_id: service.id,
        //                     id: null
        //                 }));
        //                 const existingIds = new Set(item.service_data.map(service => service.id));
        //                 const filteredNewServiceData = newServiceData.filter(service => {
        //                     if (existingIds.has(service.service_details_id)) {
        //                         errorMessage('Already Service is Added')
        //                         return false;
        //                     }
        //                     return true;
        //                 });
        //                 return {
        //                     ...item,
        //                     service_data: [
        //                         ...item.service_data,
        //                         ...filteredNewServiceData
        //                     ]
        //                 };
        //             }
        //             return item;
        //         });
        //     });
        // } else {
        //     setheadTbl((prev) => {
        //         return prev.map((item) => {
        //             if (item.service_head === editHead) {
        //                 const newServiceData = selPack.line_items.map((service, i) => ({
        //                     ...service,
        //                     quantity: service.quantity ? service.quantity : 1,
        //                     index_no: i + 1,
        //                     drug_config_id: service.drug_config_id,
        //                 }));
        //                 const existingIds = new Set(item.service_data.map(service => service.drug_config_id));

        //                 const duplicates = [];
        //                 const filteredNewServiceData = newServiceData.filter(lineItem => {
        //                     if (existingIds.has(lineItem.drug_config_id)) {
        //                         errorMessage(`Already Drug is Added`);
        //                         return false;
        //                     }
        //                     return true;
        //                 });

        //                 return {
        //                     ...item,
        //                     service_data: [
        //                         ...item.service_data,
        //                         ...filteredNewServiceData.map((lineItem, i) => ({
        //                             drug_config_id: lineItem.drug_config_id,
        //                             service_name: lineItem.drug_name,
        //                             service_type: lineItem.drug_type,
        //                             quantity: lineItem.quantity,
        //                             amount: lineItem.amount,
        //                             drug_strength: lineItem.drug_strength,
        //                             dosage_type: lineItem.dosage_type,
        //                             index_no: i + 1,
        //                         }))
        //                     ]
        //                 };
        //             }
        //             return item;
        //         });
        //     });
        // }
        setheadTbl((prev) => {
            return prev.map((item) => {
                if (item.service_head === editHead) {
                    item.assorted_head_type = states.selectedTypeRadio
                    const newServiceData = selPack.line_items.map((service, i) => ({
                        ...service,
                        amount: service?.amount,
                        quantity: service.quantity ? service.quantity : 1,
                        index_no: i + 1,
                        drug_config_id: service.drug_config_id,
                        drug_amount: +service?.amount_per_unit,
                    }));
                    const existingIds = new Set(item.service_data.map(service => service.drug_config_id));

                    const duplicates = [];
                    const filteredNewServiceData = newServiceData.filter(lineItem => {
                        if (existingIds.has(lineItem.drug_config_id)) {
                            errorMessage(`Already Drug is Added`);
                            return false;
                        }
                        return true;
                    });

                    return {
                        ...item,
                        service_data: [
                            ...item.service_data,
                            ...filteredNewServiceData.map((lineItem, i) => ({
                                drug_config_id: lineItem.drug_config_id,
                                service_name: lineItem.drug_name,
                                service_type: lineItem.drug_type,
                                quantity: lineItem.quantity,
                                amount: lineItem.amount,
                                drug_amount: lineItem?.amount_per_unit,
                                drug_strength: lineItem.drug_strength,
                                dosage_type: lineItem.dosage_type,
                                index_no: i + 1,
                                amount: lineItem?.amount
                            }))
                        ]
                    };
                }
                return item;
            });
        });
        setselPack(null)
    }
    const onAddSubService = () => {
        if (!serviceType || !serviceName || !serAmt) {
            errorMessage('Please Enter All Details');
            return;
        } else if (selPharmacy === null && states.selectedTypeRadio === 'Inhouse Drug') {
            errorMessage('Select Pharmacy');
            return;
        }

        let newService = {};
        // if (!isDrug) {
        if (states.selectedTypeRadio === 'Service') {
            newService = {
                service_type: serviceType?.service_head_name || serviceType,
                service_name: serviceName?.service_name || serviceName,
                quantity: serviceQty || 1,
                amount: +serAmt,
                service_details_id: serviceType?.service_details_id || EditID,
                service_config_id: serviceType?.service_details_id || EditID
            };
        } else if (states.selectedTypeRadio === 'Inhouse Drug') {
            newService = {
                service_type: serviceType?.drug_name || serviceName,
                service_name: serviceType?.drug_name || serviceName,
                quantity: serviceQty || 1,
                amount: +serAmt,
                drug_ms_id: serviceType?.drug_ms_id || EditID,
                in_stock: +maxQty
            };
        } else {
            newService = {
                service_type: serviceName?.drug_name || serviceName,
                service_name: serviceName?.drug_name || serviceName,
                quantity: serviceQty || 1,
                amount: +serAmt,
                drug_config_id: serviceName?.id || EditID,
                drug_amount: +drugAmt
            };
        }

        setheadTbl((prev) => {
            return prev.map((item) => {
                if (item.service_head === editHead) {
                    item.assorted_head_type = states.selectedTypeRadio
                    item.pharmacy_id = selPharmacy?.pharmacy_id || null
                    item.sub_location_id = selPharmacy?.sub_pharmacy_id || null
                    if (EditID) {
                        return {
                            ...item,
                            service_data: item.service_data.map((service) =>
                                (service.drug_config_id || service.service_details_id || service.service_config_id || service.drug_ms_id) ===
                                    (newService.drug_config_id || newService.service_details_id || newService.service_config_id || newService.drug_ms_id)
                                    ? { ...service, ...newService }
                                    : service
                            ),
                        };
                    } else {
                        const isDuplicate = item.service_data.some(
                            (service) =>
                                (states.selectedTypeRadio === 'External Drug' ? service.drug_config_id : states.selectedTypeRadio === 'Inhouse Drug' ? service.drug_ms_id : (service.service_config_id || service.service_details_id)) ===
                                (states.selectedTypeRadio === 'External Drug' ? newService.drug_config_id : states.selectedTypeRadio === 'Inhouse Drug' ? newService.drug_ms_id : (newService.service_config_id || newService.service_details_id))
                        );

                        if (isDuplicate) {
                            errorMessage('Service Already Added');
                            return item;
                        }

                        const newServiceData = item.service_data.map((service, i) => ({
                            ...service,
                            index_no: i + 1,
                        }));

                        const updatedServiceData = [
                            ...newServiceData,
                            { ...newService, index_no: newServiceData.length + 1 },
                        ];

                        return {
                            ...item,
                            service_data: updatedServiceData,
                        };
                    }
                }
                return item;
            });
        });
        setserviceType(null);
        setserviceName(null);
        setserviceQty('');
        setserAmt('');
        setEditID(null);
        setIsDrugEdit(false)
        setEditData((prev) => ({ ...prev, assHeadEdit: false }))
    };

    const showServiceRow = () => {
        try {
            let disFeild = (Index == undefined && Index == null && !editHead)
            return (
                <TableRow>
                    <TableCell colSpan={2}>{autoFeild('Search Service Head / Service Name *', 'serviceHead', serviceType, serTypeData, '23vw', disFeild)}</TableCell>
                    <TableCell>{autoFeild('Amount *', 'serAmt', serAmt, [], '10vw', disFeild)}</TableCell>
                    <TableCell sx={{ width: '4vw', padding: '0.5vw' }}>
                        <Tooltip placement='top' title={'Add'}>
                            <IconButton size='small' onClick={() => { onAddSubService() }}>
                                <img component={'img'} src={ImagePaths.AddUserButton.default} alt='plus' style={{ width: '1.2vw', height: '1.2vw' }} />
                            </IconButton>
                        </Tooltip>
                    </TableCell>
                </TableRow>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const showDrugRow = () => {
        try {
            let disFeild = (Index == undefined && Index == null && !editHead)
            return (
                <TableRow>
                    <TableCell>{autoFeild('Search Drug Name *', 'drugName', serviceType, states.selectedTypeRadio === 'Inhouse Drug' ? drugData : MediserNameData, '18vw', disFeild, (states.selectedTypeRadio === 'Inhouse Drug' ? 'inhouse' : ''))}</TableCell>
                    <TableCell sx={{ width: '6vw', padding: '0.5vw' }}>{autoFeild('Quantity', 'serviceQty', serviceQty, [], '5vw', (disFeild))}</TableCell>
                    <TableCell>{autoFeild('Amount *', 'serAmt', serAmt, [], '10vw', (states.selectedTypeRadio === 'Inhouse Drug' ? false : true))}</TableCell>
                    <TableCell sx={{ width: '4vw', padding: '0.5vw' }}>
                        <Tooltip placement='top' title={'Add'}>
                            <IconButton size='small' onClick={() => { onAddSubService() }}>
                                <img component={'img'} src={ImagePaths.AddUserButton.default} alt='plus' style={{ width: '1.2vw', height: '1.2vw' }} />
                            </IconButton>
                        </Tooltip>
                    </TableCell>
                </TableRow>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const SubServicetbl = () => {
        let disFeild = (Index == undefined && Index == null && !editHead)
        let headTblData = headTbl?.filter(item => item.service_head === editHead).some((item, i) => (
            item?.service_data?.length > 0
        ))
        return (
            <Box sx={{ width: '52vw', height: '60vh' }}>
                {/* <Box sx={{ height: '8vh', paddingTop: '.5vw', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                    <Autocomplete
                        size={'small'}
                        disabled={disFeild}
                        options={isDrug ? DrugPackage : IPPackage}
                        getOptionLabel={(option) => isDrug ? option.pack_name : option.package_name}
                        value={selPack}
                        sx={{ width: '14vw', marginRight: '1vw' }}
                        onChange={(event, newValue) => { onAddType(event, newValue) }}
                        renderInput={(params) => <TextField {...params} placeholder={isDrug ? 'Select Drug Package' : 'Select Service Package'} variant='outlined' />}
                    />
                    <Button size='small' variant='contained' disabled={!selPack} sx={{ textTransform: 'capitalize', width: '4vw', marginRight: '1vw' }} onClick={() => { addServiceTbl() }}>Add</Button>
                    <Typography sx={{ marginRight: '1vw' }}>Service</Typography>
                    <FormControlLabel disabled={disFeild} control={<Switch size='small' checked={isDrug} onChange={(e) => {
                        setisDrug(e.target.checked)
                        setserviceType(null)
                        setserviceName(null)
                        setserviceQty('')
                        setserAmt('')
                        setEditID(null)
                        setIsDrugEdit(false)
                    }} />} label="Medication" />
                </Box> */}
                <Box sx={{ height: '8vh', paddingTop: '.5vw', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                    {states.selectedTypeRadio === 'External Drug' ?
                        <Box component={'div'} display={'flex'}>
                            <Autocomplete
                                size={'small'}
                                disabled={disFeild}
                                options={DrugPackage}
                                getOptionLabel={(option) => option.pack_name}
                                value={selPack}
                                sx={{ width: '14vw', marginRight: '1vw' }}
                                onChange={(event, newValue) => { onAddType(event, newValue) }}
                                renderInput={(params) => <TextField {...params} placeholder={'Select Drug Template'} variant='outlined' />}
                            />
                            <Button size='small' variant='contained' disabled={!selPack} sx={{ textTransform: 'capitalize', width: '4vw', marginRight: '1vw' }} onClick={() => { addServiceTbl() }}>Add</Button>
                        </Box> :
                        states.selectedTypeRadio === 'Inhouse Drug' ?
                            <Box component={'div'} display={'flex'}>
                                <Autocomplete
                                    size={'small'}
                                    disabled={disFeild || editData?.assHeadEdit || headTblData} 
                                    options={pharmacyList}
                                    getOptionLabel={(option) => typeof (option) === 'symbol' ? option : option.module_name}
                                    value={selPharmacy}
                                    sx={{ width: '14vw', marginRight: '1vw' }}
                                    onChange={(event, newValue) => {
                                        setserviceType(null);
                                        setserviceName(null);
                                        setserviceQty('');
                                        setserAmt('');
                                        setDrugData([])
                                        setSelPharmacy(newValue)
                                    }}
                                    renderInput={(params) => <TextField {...params} disabled={disFeild || editData?.assHeadEdit || headTblData} placeholder={'Select Pharmacy *'} variant='outlined' />}
                                />
                            </Box> : null}
                    <RadioGroup row value={states.selectedTypeRadio}
                        onChange={(e) => {
                            let value = e.target.value
                            if (headTblData) {
                                setOpenAlertPopup(true)
                                setRadioType(value)
                            } else {
                                setserAmt('')
                                setserviceName(null)
                                setserviceType(null)
                                setserviceQty('')
                                headTbl?.map((item) => item?.service_head === editHead ? item.service_data = [] : item)
                                setStates((prev) => ({ ...prev, selectedTypeRadio: value }))
                                setServiceInputValue('')
                                setSearchDrug('')
                                setDrugData([])
                                setserTypeData([])
                                setTimeout(() => setRadioType(''), 50)
                            }
                        }}
                    >
                        <FormControlLabel value="Service" control={<Radio size='small' disabled={disFeild || editData?.assHeadEdit || headTblData} />} label="Service" />
                        <FormControlLabel value="External Drug" control={<Radio size='small' disabled={disFeild || editData?.assHeadEdit || headTblData} />} label="External Drug" />
                        {loginInfo?.show_assorted_inhouse_drug && <FormControlLabel value="Inhouse Drug" control={<Radio size='small' disabled={disFeild || editData?.assHeadEdit || headTblData} />} label="InHouse Drug" />}
                    </RadioGroup>
                </Box>
                <TableContainer component={Paper} sx={{ height: '52vh' }}>
                    <Table size='small' sx={{ width: '52vw' }} aria-label="simple table">
                        {/* <TableHead sx={{ backgroundColor: '#FAF9F9' }}>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold', width: '15vw', padding: '0.5vw' }}>Type</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', width: '15vw', padding: '0.5vw' }}>Name</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', width: '6vw', padding: '0.5vw' }}>Quantity</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', width: '6vw', padding: '0.5vw' }}>Amount</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', width: '4vw', padding: '0.5vw' }}>Action</TableCell>
                            </TableRow>
                        </TableHead> */}
                        <TableHead sx={{ backgroundColor: '#FAF9F9' }}>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold', width: '35%', padding: '0.5vw' }}>{states.selectedTypeRadio === 'Service' ? 'Service Head' : 'Drug Name'}</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', width: '35%', padding: '0.5vw' }}>{states.selectedTypeRadio === 'Service' ? 'Service Name' : 'Qty'}</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', width: '15%', padding: '0.5vw' }}>Amount</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', width: '15%', padding: '0.5vw' }}>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {states.selectedTypeRadio === 'Service' ? showServiceRow() : showDrugRow()}
                            {/* <TableRow>
                                <TableCell sx={{ width: '15vw', padding: '0.5vw' }} >{autoFeild('Type', 'serviceType', serviceType, isDrug ? list : serTypeData, '15vw', disFeild)}</TableCell>
                                <TableCell sx={{ width: '15vw', padding: '0.5vw' }}>{autoFeild('Name', 'serviceName', serviceName, isDrug ? MediserNameData.filter((item) => serviceType === item.drug_type) : serNameData, '15vw', disFeild)}</TableCell>
                                <TableCell sx={{ width: '6vw', padding: '0.5vw' }}>{autoFeild('Quantity', 'serviceQty', serviceQty, [], '5vw', (disFeild || (!isDrug && !isDrugEdit)))}</TableCell>
                                <TableCell sx={{ width: '6vw', padding: '0.5vw' }}>{autoFeild('Amount', 'serAmt', serAmt, [], '5vw', disFeild)}</TableCell>
                                <TableCell sx={{ width: '4vw', padding: '0.5vw' }}>
                                    <Tooltip placement='top' title={'Add'}>
                                        <IconButton size='small' onClick={() => { onAddSubService() }}>
                                            <img component={'img'} src={ImagePaths.AddUserButton.default} alt='plus' style={{ width: '1.2vw', height: '1.2vw' }} />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                            </TableRow> */}
                            {headTbl.length > 0 ? headTbl.filter(item => item.service_head === editHead).map((item, i) => (
                                item.service_data.length > 0 ? item.service_data.map((data, index) => (
                                    <TableRow key={index}>
                                        {/* <TableCell sx={{ width: '15vw', padding: '0.5vw' }}>
                                            {data.service_type?.length > 25 ?
                                                <Tooltip title={data.service_type} placement='top'>
                                                    <Typography fontSize={'1vw'}>{data.service_type.slice(0, 22) + '...'}</Typography>
                                                </Tooltip> :
                                                <Typography fontSize={'1vw'}>{data.service_type || '-'}</Typography>
                                            }
                                        </TableCell> */}
                                        <TableCell sx={{ width: '15vw', padding: '0.5vw' }}>{states.selectedTypeRadio === 'Service' ? ContentInTooltip((data.service_type || "-"), 25) : ContentInTooltip((data.service_name || "-"), 25)}</TableCell>
                                        <TableCell sx={{ width: '6vw', padding: '0.5vw' }}>{states.selectedTypeRadio === 'Service' ? ContentInTooltip((data.service_name || "-"), 25) : (data.quantity || '-')} </TableCell>
                                        <TableCell sx={{ width: '6vw', padding: '0.5vw' }}>{AmountFormat(data.amount || 0)?.replace(`${CurrencySymbol}`, "")}</TableCell>
                                        <TableCell sx={{ width: '4vw', padding: '0.5vw' }}>
                                            <Stack direction="row" alignItems="center" spacing={4}>
                                                <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
                                                    <CommonEditButton size="1.5vw" disable={editData?.assHeadEdit} onClick={() => {
                                                        // setserviceType(data.service_type)
                                                        setserviceType(data.service_name)
                                                        setserviceName(data.service_name)
                                                        setserviceQty(data.quantity)
                                                        setserAmt(data.amount)
                                                        setEditID(data?.service_config_id || data.service_details_id || data.drug_config_id || data?.drug_ms_id)
                                                        setisDrug(false)
                                                        setIsDrugEdit((data.drug_config_id || data?.drug_ms_id) ? true : false)
                                                        setMaxQty(data?.in_stock)
                                                        setEditData((prev) => ({ ...prev, assHeadEdit: true }))
                                                        setDrugAmt(data?.drug_amount)
                                                    }} />
                                                    <CommonDeleteButton size="1.5vw" disable={editData?.assHeadEdit} onClick={() => {
                                                        setheadTbl((prev) => {
                                                            return prev.map((item) => {
                                                                if (item.service_head === editHead) {
                                                                    const updatedServiceData = [...item.service_data];
                                                                    if (updatedServiceData[index]) {
                                                                        const removedService = updatedServiceData[index];
                                                                        if (EditListID && removedService.id) {
                                                                            setdeletedIDs((prevIDs) => [...prevIDs, removedService.id]);
                                                                        }
                                                                        updatedServiceData.splice(index, 1);
                                                                    } else {
                                                                        errorMessage("Invalid index provided for service_data.");
                                                                    }
                                                                    const newTotalAmount = updatedServiceData.reduce(
                                                                        (sum, service) => sum + Number(service.amount || 0),
                                                                        0
                                                                    );

                                                                    return {
                                                                        ...item,
                                                                        service_data: updatedServiceData,
                                                                        total_amount: +(newTotalAmount.toFixed(2)),
                                                                    };
                                                                }

                                                                return item;
                                                            });
                                                        });
                                                    }} />
                                                </Stack>
                                            </Stack>
                                        </TableCell>
                                    </TableRow>
                                )) : (
                                    <TableRow key="no-data">
                                        <TableCell colSpan={5} align="center">{'No Services Available Under this Category'}</TableCell>
                                    </TableRow>
                                )
                            )) : (
                                <TableRow>
                                    <TableCell colSpan={5} align="center">{'No Records To Be Shown'}</TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        )

    }

    const onSaveAssPack = () => {
        try {
            setisloader(true)
            let EmptyheadTbl = headTbl.length === 0
            let EmptyServiceData = headTbl.some(item => item.service_data?.length === 0);
            if (!assData.assPackName || !assData.finalAmt) {
                setisloader(false)
                errorMessage('Please Enter the Package Details')
            } else if (EmptyheadTbl) {
                setisloader(false)
                errorMessage('Please add At least one Services Heads');
            } else if (EmptyServiceData) {
                setisloader(false)
                errorMessage('Please add Services for All Heads');
            } else if (appliedFor === null) {
                setisloader(false)
                errorMessage('Please Select Applied For');
            } else {
                let data = {
                    "pack_name": assData?.assPackName,
                    "pack_code": assData?.assPackCode ? assData?.assPackCode : '',
                    "pack_amount": assData?.finalAmt,
                    "line_items": headTbl,
                    "head_ids": headIDs || [],
                    "delete_ids": deletedIDs || [],
                    "billing_display": states.selectedRadio,
                    "apply_for": appliedFor?.value ? appliedFor?.value : appliedFor
                }
                if (EditListID) {
                    data['id'] = EditListID
                }
                RestAPIService.create(data, Serviceurls.ASS_GET_ASSORTED_PACKAGE)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            setisloader(false)
                            setassData(assStates)
                            history.push({ pathname: "/Settings/NewService/AssortedPackage", states: { alertmsg: response.data.message ? response.data.message : "" } })
                            setEditListID(null)
                        }
                    }).catch(e => {
                        setisloader(false)
                        if (e?.response?.data?.status === 'fail') {
                            errorMessage(e.response.data.message)
                        } else {
                            errorMessage(e.message)
                        }
                    })

            }
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const renderAlertPopup = () => {
        try {
            return (
                <Dialog open={openAlertPopup} maxWidth='xs' fullWidth>
                    <Box component={'div'} className='com_billing_popup'>
                        <Box component={'div'} p={'0rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
                            <Typography fontSize={'1rem'} fontWeight={600}>Change Service Type</Typography>
                            <IconButton
                                onClick={() => setOpenAlertPopup(false)}
                            >
                                <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1dvw'} width={'1dvw'} />
                            </IconButton>
                        </Box>
                        <Box component={'div'} p={'0.5rem'} display={'flex'} justifyContent={'center'} alignItems={'center'} flexDirection={'column'}>
                            <Typography fontSize={'1.1rem'} fontWeight={600}>Are you sure do you want to change the service ?</Typography>
                            <Typography fontSize={'1.1rem'} fontWeight={600} color={'red'}>*It will affect the current data.</Typography>
                        </Box>
                        <Box component={'div'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'} p={'0.5rem'}>
                            <Button variant='outlined' sx={{ height: '4.5dvh', textTransform: 'capitalize', mr: '1rem' }}
                                onClick={() => setOpenAlertPopup(false)} >Cancel</Button>
                            <Button variant='contained' sx={{ height: '4.5dvh', textTransform: 'capitalize', mr: '1rem' }}
                                onClick={() => {
                                    setOpenAlertPopup(false)
                                    setserAmt('')
                                    setserviceName(null)
                                    setserviceType(null)
                                    setserviceQty('')
                                    headTbl?.map((item) => item?.service_head === editHead ? item.service_data = [] : item)
                                    setStates((prev) => ({ ...prev, selectedTypeRadio: radioType }))
                                    setServiceInputValue('')
                                    setSearchDrug('')
                                    setDrugData([])
                                    setserTypeData([])
                                    setTimeout(() => setRadioType(''), 50)
                                }}
                            >Change Service</Button>
                        </Box>
                    </Box>
                </Dialog>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    return (
        <Box component={'div'} sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box component={'div'} height={'5vh'} display={'flex'} alignItems={'center'} sx={{ backgroundColor: 'white', borderBottom: '1px solid lightgray' }}>
                <IconButton onClick={() => { history.push("/Settings/NewService/AssortedPackage") }}>
                    <ChevronLeftIcon color='primary' />
                </IconButton>
                <Typography color={Colors.SecondaryText} fontWeight={600} fontSize={"0.95vw"}>{'Back To Assorted Package'}</Typography>
            </Box>
            <Paper sx={{ height: '17dvh' }} elevation={1}>
                <Box component={'div'} borderBottom={'1.5px solid lightgray'} p={'0.5rem'}>
                    <Typography fontWeight={600} fontSize={'0.9rem'}>Assorted Package Configuration</Typography>
                </Box>
                <Box component={'div'} p={'0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                    <Box component={'div'}>
                        <Box display={'flex '}>
                            {textBox("Assorted Package Code", 'assPackCode', assData.assPackCode, '15vw', true)}
                            {textBox("Assorted Package Name *", 'assPackName', assData.assPackName, '15vw')}
                            {textBox("Final Amount *", 'finalAmt', assData.finalAmt, '15vw')}
                            <Autocomplete
                                disabled={editData?.hasServiceData}
                                size='small'
                                sx={{ width: '15dvw' }}
                                options={applied_for}
                                getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.label}
                                value={appliedFor}
                                onChange={(e, value) => setAppliedFor(value)}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        label='Applied For *'
                                    />
                                }
                            />
                        </Box>
                        <Box component={'div'} display={'flex'} alignItems={'center'}>
                            <Typography fontSize={'0.9rem'} fontWeight={600} mr={'1rem'}>In Billing Display by?</Typography>
                            <RadioGroup row value={states.selectedRadio}
                                onChange={(e) => {
                                    let value = e.target.value
                                    setStates((prev) => ({ ...prev, selectedRadio: value }))
                                }}
                            >
                                <FormControlLabel value="Assorted Package Name" control={<Radio size='small' />} label="Assorted Package Name" />
                                <FormControlLabel value="Assorted Service Head" control={<Radio size='small' />} label="Assorted Service Head" />
                                <FormControlLabel value="Service Head" control={<Radio size='small' />} label="Service Head" />
                                <FormControlLabel value="Service Name" control={<Radio size='small' />} label="Service Name" />
                            </RadioGroup>
                        </Box>
                    </Box>
                    <Box component={'div'}>
                        <Button size='small' variant='contained' sx={{ textTransform: 'capitalize', width: '7vw', marginLeft: '1vw' }} disabled={isloader} onClick={() => { onSaveAssPack() }}>{fromUpdate ? 'Update' : 'Save'}</Button>
                    </Box>
                </Box>
            </Paper>
            {/* <Box component={'div'} sx={{ height: '8vh', width: '93vw', backgroundColor: 'white', padding: '.6vw', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', }}>
                    {textBox("Assorted Package Code", 'assPackCode', assData.assPackCode, '15vw')}
                    {textBox("Assorted Package Name", 'assPackName', assData.assPackName, '15vw')}
                    {textBox("Final Amount", 'finalAmt', assData.finalAmt, '15vw')}
            </Box> */}
            <Box component={'div'} sx={{ height: '65vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white' }}>
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                    {Servicetbl()}
                    {SubServicetbl()}
                </Box>
                {/* <Box component={'div'} sx={{ marginTop: '.5vw', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                    <Box sx={{ width: '9vw' }}>
                        <Button size='small' variant='contained' sx={{ textTransform: 'capitalize', width: '7vw', marginLeft: '1vw' }} disabled={isloader} onClick={() => { onSaveAssPack() }}>Save</Button>
                    </Box>
                </Box> */}
            </Box>
            {renderAlertPopup()}
            {message.isErrorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={message.isErrorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {message.successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={message.successMsgText}
                    msgPop={msgClose}
                />
                : null}
            <Loader loaderOpen={isloader} />
        </Box>
    )
}

